<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="03" :question="question" :modalActivator="modalActivator" @activateModal="modalActive=true"></QuestionTitle>
        <div class="container-70">
            <selection-box :values="values" v-model="result" @update:modelValue="saveAndContinue('profilConsommateur', JSON.stringify(result.label), result.value)"></selection-box>
            <AvancementLine percent="100%" class="mt-50px"></AvancementLine>
        </div>
        <ModalInfo @closeModal="modalActive=false" v-if="modalActive">
            <h3 class="modal-title">Profil de consommation</h3>
            <p class="modal-text">Dans l'objectif de créer un outil simple et convivial, nous avons établi trois profils de consommation moyens pour illustrer différents modes de vie. Ils sont déterminés en fonction de votre situation géographique par rapport à un centre urbain ou aux efforts effectués pour réduire votre impact environnemental. Choisissez celui qui correspond le mieux à votre situation.</p>
        </ModalInfo>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import SelectionBox from '@/components/SelectionBox.vue'
import AvancementLine from '@/components/AvancementLine.vue'
import ModalInfo from '@/components/ModalInfo.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            question:'À quel profil de consommateur votre ménage s\'associe le plus?',
            modalActive:false,
            modalActivator:true,
            values: [
                {
                    img: require('@/assets/images/building.png'),
                    label: 'Urbain ou écologique',
                    value: "/resultats",
                    description:"Vous vivez dans un quartier de la ville avec tous les services à proximité et vous utilisez principalement le transport en commun ou le transport actif. Vous habitez dans un logement de taille modeste et vous réalisez beaucoup d'efforts pour réduire votre impact environnemental. Vous avez un régime alimentaire principalement végétal."
                },
                {
                    img: require('@/assets/images/house.png'),
                    label: 'Périphérie ou sensibilisé à l\'environnement',
                    value: "/resultats",
                    description:"Vous habitez dans un logement de taille moyenne et vous utilisez principalement la voiture comme moyen de transport. Vous réalisez quelques efforts pour réduire votre impact environnemental comme le tri des matières résiduelles. Vous vous limitez à un voyage à l'étranger par année et vous avez un régime alimentaire omnivore."
                   
                },
                {
                    img: require('@/assets/images/cabin.png'),
                    label: 'Éloigné ou en début de sensibilisation',
                    value: "/resultats",
                    description:"Vous vivez dans un secteur plus éloigné ou rural qui offre peu de commodités à proximité. Vous utilisez donc exclusivement la voiture pour vos déplacements. Vous habitez dans un logement de grande taille et vous avez un régime alimentaire basé principalement sur les protéines animales. Vous faites plusieurs voyages à l'étranger par année. Vous commencez à vous renseigner pour améliorer votre impact environnemental."
                }
            ]
        }
    },
    methods:{
        clearPreviousForm(){
            sessionStorage.clear()
        }
    }, 
    components: {
        QuestionTitle,
        SelectionBox,
        ModalInfo,
        AvancementLine
    },
    mixins:[utils],
    mounted(){
        this.clearPreviousForm()
    }
}
</script>